import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/common/warning-outline.png'


const _withScopeId = n => (_pushScopeId("data-v-7d5c6293"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "confrim-footer flex f-jcc"
}
const _hoisted_3 = {
  key: 1,
  src: _imports_0
}
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    class: "confirm-wrap",
    visible: _ctx.visible,
    wrapClassName: !_ctx.visible ? 'hide-modal' : '',
    width: _ctx.dialogWidth,
    closable: _ctx.showClose,
    centered: _ctx.isNoFooter,
    maskClosable: true,
    onCancel: _ctx.cancelConfirm
  }, _createSlots({
    closeIcon: _withCtx(() => [
      _createElementVNode("img", {
        style: {"width":"24px","height":"24px"},
        src: require('@/assets/common/close.png')
      }, null, 8, _hoisted_1)
    ]),
    footer: _withCtx(() => [
      _renderSlot(_ctx.$slots, "footer", {}, () => [
        (_ctx.showLeftBtn || _ctx.showRightBtn)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_ctx.showLeftBtn)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    class: "cancel-btn",
                    key: "back",
                    onClick: _ctx.onLeftBtnClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.leftBtn), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true),
              (_ctx.showRightBtn)
                ? (_openBlock(), _createBlock(_component_a_button, {
                    class: "ok-btn",
                    key: "submit",
                    type: "primary",
                    onClick: _ctx.onRightBtnClick
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.rightBtn), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ], true)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["confirm-content", _ctx.isNoFooter?'confirm_content_self':'']),
        style: _normalizeStyle(`width: ${_ctx.contentWidth};`)
      }, [
        (!_ctx.useHtml)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (_ctx.$slots['icon'])
                ? _renderSlot(_ctx.$slots, "icon", { key: 0 }, undefined, true)
                : (_ctx.hideIcon === false)
                  ? (_openBlock(), _createElementBlock("img", _hoisted_3))
                  : _createCommentVNode("", true),
              _createElementVNode("div", null, _toDisplayString(_ctx.content), 1)
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.$slots['content'])
                ? _renderSlot(_ctx.$slots, "content", { key: 0 }, undefined, true)
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    style: _normalizeStyle(`text-align: ${_ctx.contentAlign};`),
                    innerHTML: _ctx.content
                  }, null, 12, _hoisted_4))
            ], 64))
      ], 6)
    ]),
    _: 2
  }, [
    (_ctx.$slots['title'])
      ? {
          name: "title",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "title", {}, undefined, true)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["visible", "wrapClassName", "width", "closable", "centered", "onCancel"]))
}